
<template>
    <div>
        <Schedule :crm="crm" :user="user" :roles="roles" :officers="officers" ref="table"
            :crm-setting-value="crmSettingValue">
        </Schedule>
    </div>
</template>
  
<script>
import Schedule from './Schedule.vue';

//   import axios from "axios";

export default {
    components: {
        Schedule,
    },
    data() {
        return {}
    },
    created() {
        console.log(' this.freqSettingKey', this.freqSettingKey)
        this.$store.dispatch('company/fetchConfiguration', this.freqSettingKey)
        this.$store.dispatch('roles/fetchAll')
        this.$store.dispatch('assets/listTypes')
        this.$store.dispatch('interactionType/fetchAll')

        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('locations/fetchWarehouses')
    },
    mounted() {
        this.$store.dispatch('users/fetchAll')
        this.$store.dispatch('company/fetch')
    },

    computed: {
        crmSettingValue() {
            return this.$store.getters['company/crmSettingValue']
        },
        crmsettingsKey() {
            return this.$store.state.company.settingKeys.crmsettingsKey
        },
        roles() {
            return this.$store.state.roles.items
        },
        user() {
            return this.$store.state.user || {}
        },
        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        crm() {
            return this.$route.name.slice(0, 3) === 'crm'
        },
    },
    watch: {
        crm: function () {
            this.$nextTick(() => {
                this.$refs.table.pureSearch(true)
            })
        },
    },
}
</script>
 